
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Soft_tissue_sarcoma_of_extremities_and_trunk",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Soft_tissue_sarcoma_of_extremities_and_trunk.vue